(() => {
  if (window.PFQuizControllerLoaded) return;
  window.PFQuizControllerLoaded = true;

  const selector = '[data-pf-quiz-screen]';

  const screens = () => Array.from(document.querySelectorAll(selector));

  const showScreen = (targetIndex, shouldFocus = true) => {
    const allScreens = screens();
    if (!allScreens.length) return;

    const safeIndex = Math.max(0, Math.min(targetIndex, allScreens.length - 1));
    allScreens.forEach((screen, index) => {
      const isActive = index === safeIndex;
      screen.hidden = !isActive;
      screen.setAttribute('aria-hidden', String(!isActive));
    });

    const activeScreen = allScreens[safeIndex];
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (shouldFocus) {
      const heading = activeScreen.querySelector('[data-pf-quiz-heading]');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        window.setTimeout(() => heading.focus({ preventScroll: true }), 220);
      }
    }
  };

  const currentIndex = (element) => screens().indexOf(element.closest(selector));

  const updateCustomerTags = () => {
    const tags = new Set(['pf-quiz', 'quiz']);
    document.querySelectorAll('[data-pf-quiz-question] [data-pf-quiz-answer][aria-pressed="true"]').forEach((answer) => {
      const tag = answer.dataset.pfQuizAnswerTag;
      if (tag) tags.add(tag);
    });

    document.querySelectorAll('[data-pf-quiz-tags]').forEach((input) => {
      input.value = Array.from(tags).join(',');
    });
  };

  const updateEmailSubmit = (input) => {
    const form = input.closest('form');
    const submit = form && form.querySelector('[data-pf-quiz-submit]');
    if (!submit) return;
    submit.disabled = !input.value.trim() || !input.validity.valid;
  };

  document.addEventListener('input', (event) => {
    const email = event.target.closest('[data-pf-quiz-email]');
    if (email) updateEmailSubmit(email);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.pf-quiz__email-form');
    if (!form) return;

    updateCustomerTags();
    const returnTo = form.querySelector('[data-pf-quiz-return-to]');
    const skip = form.parentElement.querySelector('.pf-quiz__skip');
    if (returnTo && skip) returnTo.value = skip.getAttribute('href');
  });

  document.addEventListener('click', (event) => {
    const answer = event.target.closest('[data-pf-quiz-answer]');
    if (answer) {
      const question = answer.closest('[data-pf-quiz-question]');
      const isMultiple = question.dataset.selection === 'multiple';

      if (isMultiple) {
        answer.setAttribute('aria-pressed', String(answer.getAttribute('aria-pressed') !== 'true'));
      } else {
        question.querySelectorAll('[data-pf-quiz-answer]').forEach((option) => {
          option.setAttribute('aria-pressed', String(option === answer));
        });
      }
      updateCustomerTags();
      return;
    }

    const next = event.target.closest('[data-pf-quiz-next]');
    if (next) {
      showScreen(currentIndex(next) + 1);
      return;
    }

    const back = event.target.closest('[data-pf-quiz-back]');
    if (back) showScreen(currentIndex(back) - 1);
  });

  document.addEventListener('shopify:section:select', (event) => {
    const selected = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    const screen = selected && selected.querySelector(selector);
    if (screen) showScreen(screens().indexOf(screen), false);
  });

  const init = () => {
    const allScreens = screens();
    if (!allScreens.length) return;
    updateCustomerTags();
    document.querySelectorAll('[data-pf-quiz-email]').forEach(updateEmailSubmit);
    const returnedForm = document.querySelector('[data-pf-quiz-form-status="error"], [data-pf-quiz-form-status="success"]');
    if (returnedForm) {
      showScreen(currentIndex(returnedForm), false);
      return;
    }
    const requestedStart = allScreens.findIndex((screen) => screen.dataset.startVisible === 'true');
    showScreen(requestedStart >= 0 ? requestedStart : 0, false);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
